import {
  useAllParticipants,
  useConferenceStore,
  useConnectionStore,
  useLocalParticipant,
} from '@cometchat/calls-sdk-core';
import './style.css';

export const DevOverlay = () => {
  const connectionStatus = useConnectionStore(state => state.connectionStatus);
  const connectionError = useConnectionStore(state => state.error);
  const conferenceStatus = useConferenceStore(state => state.conferenceStatus);
  const conferenceError = useConferenceStore(state => state.conferenceError);
  const localParticipant = useLocalParticipant();
  const allParticipants = useAllParticipants();
  const p2p = useConferenceStore(state => state.p2p);
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  return (
    <div className="cometchat-calls-dev-overlay">
      <div>Connection Status: {connectionStatus}</div>
      {connectionError && <div>Connection Error: {connectionError}</div>}
      <div>Conference Status: {conferenceStatus}</div>
      {conferenceError && <div>Conference Error: {conferenceError}</div>}
      <div>Role: {localParticipant.role}</div>
      <div>Total Participants: {allParticipants.length}</div>
      <div>P2P: {p2p ? 'true' : 'false'}</div>
    </div>
  );
};
